import ProjectCard from "./ProjectCard";

export default function MasonryGrid({ projects, empty }) {
  if (!projects || projects.length === 0) {
    return <div className="text-center py-20 text-muted-foreground">{empty || "No projects yet."}</div>;
  }
  return (
    <div className="masonry" data-testid="masonry-grid">
      {projects.map((p) => <ProjectCard key={p.project_id} project={p} />)}
    </div>
  );
}
